import { maskitoNumberOptionsGenerator } from '@maskito/kit';

import { MAX_AMOUNT, MIN_AMOUNT } from '../../utils/constants/defaultValues';

export const decimalMaskOptions = maskitoNumberOptionsGenerator({
  precision: 2,
  decimalSeparator: '.',
  min: MIN_AMOUNT,
  max: MAX_AMOUNT,
});
